import { render, staticRenderFns } from "./OpzioniOrdiniMTMComandi.vue?vue&type=template&id=0feac0fe"
import script from "./OpzioniOrdiniMTMComandi.vue?vue&type=script&lang=ts"
export * from "./OpzioniOrdiniMTMComandi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0feac0fe')) {
      api.createRecord('0feac0fe', component.options)
    } else {
      api.reload('0feac0fe', component.options)
    }
    module.hot.accept("./OpzioniOrdiniMTMComandi.vue?vue&type=template&id=0feac0fe", function () {
      api.rerender('0feac0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/OpzioniOrdiniMTMComandi.vue"
export default component.exports